import { BaseModel } from "../../../vendor_core/core/src/model/BaseModel";

class BURGameModel extends BaseModel<{}> {
    private rtp = 0;
    private minBet = 0;
    private maxBet = 0;

    public get game_rtp() {
        return this.rtp;
    }

    public get min_bet() {
        return this.minBet;
    }

    public get max_bet() {
        return this.maxBet;
    }

    public setGameRtp(payload: number) {
        this.rtp = payload;
    }

    public setMinBet(payload: number) {
        this.minBet = payload;
    }

    public setMaxBet(payload: number) {
        this.maxBet = payload;
    }
}

export default new BURGameModel();
